module.exports = __webpack_public_path__ + "static/media/successIcon.442266c7.svg";